import { atom, SetStateAction, useAtom, useAtomValue, useSetAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { useEffect } from 'react';
import { io, Socket } from 'socket.io-client';
export type Common = {
  home: string;
  socketConnection: boolean;
};

// socket은 별도 관리
const socketAtom = atom<Socket | null>(null);

// localStorage에 저장할 값만 따로 관리
const commonAtom = atomWithStorage<Common>('common', {
  home: '/room/list',
  socketConnection: true,
});

const common = atom((get) => get(commonAtom));
// 사용부
export function useCommon() {
  const [state, setState] = useAtom(commonAtom);
  const commonValue = useAtomValue(common);

  const setCommonValue = (key: string, value: any) => {
    console.log('🚀 ~ setCommonValue ~ key:', key, value);
    setState((prev: Common) => {
      return {
        ...prev,
        [key]: value,
      };
    });
  };

  return {
    ...commonValue,
    setValue: setCommonValue,
  };
}

export function useSocket() {
  const [socket, setSocket] = useAtom(socketAtom);
  const [, setCommon] = useAtom(commonAtom);
  let soc: Socket;
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!(window as any).__SOCKET__) {
      soc = io(process.env.NEXT_PUBLIC_SOCKET_HOST);
      (window as any).__SOCKET__ = soc;
      console.log('🚀 ~ useEffect ~ process.env.SOCKET_HOST:', process.env.NEXT_PUBLIC_SOCKET_HOST);
      // 연결 성공 이벤트 핸들러
      soc.on('connect', () => {
        console.log('Socket 연결 성공, id:', soc);
        setSocket(soc);
        setCommon((prev) => ({
          ...prev,
          socketConnection: true,
        }));
      });

      // // 연결 오류 이벤트 핸들러
      soc.on('connect_error', (error) => {
        console.error('Socket 연결 오류:', error);
        setSocket(null);
        setCommon((prev) => ({
          ...prev,
          socketConnection: false,
        }));
      });
    }
    // 컴포넌트 언마운트 시 소켓 정리
    return () => {
      soc?.off('connect');
      soc?.off('connect_error');
      soc?.disconnect();
    };
  }, []);

  return {
    socket,
  };
}
